import { render, staticRenderFns } from "./EvaluationCard.vue?vue&type=template&id=4d18681c&scoped=true&"
import script from "./EvaluationCard.vue?vue&type=script&lang=js&"
export * from "./EvaluationCard.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationCard.vue?vue&type=style&index=0&id=4d18681c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d18681c",
  null
  
)

export default component.exports